export default "__VITE_ASSET__BmOBcymf__"